import React, { useState, useEffect } from "react";
import "./UserReview.scss";
import axios from "axios";
import Rating from "@mui/material/Rating";
import Marquee from "../../Components/magicui/Marquee";

function UserReview() {
  const [reviews, setReviews] = useState([]);
  const [expanded, setExpanded] = useState(undefined);
  useEffect(() => {
    getReview();
  }, []);

  useEffect(() => {
    if (window.location.hash === "#review") {
      const homeSection = document.getElementById("review");
      setTimeout(() => {
        if (homeSection) {
          homeSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    }
  }, [window.location.hash]);

  const getReview = () => {
    const url = "api/public_review/get_public_review/";
    axios
      .post(url, {})
      .then((res) => {
        setReviews(res.data.reviews);
      })
      .catch((err) => console.log("err", err));
  };

  return (
    <div className="card_user_review" id="review">
      <div className="card_user_review_left">
        <h3>
          Hear it from
          <span> our Users</span>
        </h3>
        <p>
        Trusted by hundreds of professionals, businesses and their teams.
        </p>
      </div>
      <div className="card_user_review_right">
        <div className="user_review_item_wrapper">
          <div className="relative flex w-full flex-col items-center justify-center overflow-hidden rounded-lg  md:shadow-xl">
            <Marquee pauseOnHover className="[--duration:20s]">
              {reviews.map((item, index) => {
                return (
                  <button
                    onClick={() => {
                      if (expanded !== index) {
                        setExpanded(index);
                      } else {
                        setExpanded(undefined);
                      }
                    }}
                    style={{ maxHeight: expanded === index ? "none" : "290px" }}
                    className="user_review_item"
                    key={"user_review" + index}
                  >
                    <img
                      src={item.profile_picture}
                      alt="User"
                      loading="lazy"
                      decoding="async"
                      height="70"
                      width="70"
                      sizes="(max-width: 70px) 70px"
                    />
                    <h5>{item.name}</h5>
                    <span className="user_review_item_span">
                      {item.company}
                    </span>
                    <div className="read_more_con">
                      <p>
                        {expanded === index
                          ? item.comments
                          : item.comments.slice(0, 115) +
                            (item.comments.length > 115 ? "..." : "")}
                      </p>
                      {item.comments.length > 115 && (
                        <p className="read-more-button">
                          {expanded === index ? "Read less" : "Read more.."}
                        </p>
                      )}
                    </div>

                    <div className="rating_con">
                      <p>Rating</p>
                      <Rating
                        name="read-only"
                        value={item.ratings}
                        readOnly
                        className="rating_star"
                      />
                    </div>
                  </button>
                );
              })}
            </Marquee>
            <div style={{ width: "4%" }} className="pointer-events-none absolute inset-y-0 left-0 bg-gradient-to-r from-white dark:from-background"></div>
            <div style={{ width: "4%" }} className="pointer-events-none absolute inset-y-0 right-0 bg-gradient-to-l from-white dark:from-background"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserReview;
